export default "__VITE_ASSET__855e48a6__"